export const NAMESPACE = "NewFollowupForm";

export const WELCOME_COLORS = {
  0: "indigo7",
  1: "neutral5",
  2: "neutral5",
  3: "neutral5"
};

export const LOGIN_COLORS = {
  0: "neutral5",
  1: "indigo7",
  2: "neutral5",
  3: "neutral5"
};

export const GROUP_COLORS = {
  0: "neutral5",
  1: "neutral5",
  2: "indigo7",
  3: "neutral5"
};

export const CONTACT_COLORS = {
  0: "neutral5",
  1: "neutral5",
  2: "neutral5",
  3: "indigo7"
};
